import React from 'react';
import { Row, Col } from 'reactstrap';
import usePatient from '~/utils/patient/hook';
import { UncontrolledTable } from '~/components';
import { format } from 'date-fns';
import { TableFilterDateRange, TableFilterIdentitySource, TableFilterAppointmentType } from '~/components/Filters';
import NoteCell from '~/components/Patient/Identity/NoteCell';
import { MatchStatus } from '~/utils/const/identity';

const TherapyVisits = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="therapy-visits"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-therapyvisits',
        params: {
          sacwisId,
          match_status_id: MatchStatus.Approved,
          'visitdateTs__<<': format(new Date(), 'MM/DD/YYYY'),
        },
      }}
      defaultSorted={[{ id: 'visitdateTs__>>', desc: true }]}
      columns={[
        {
          id: 'visitdateTs__>>',
          Header: 'Visit Date',
          accessor: 'attributes.visitdateTs',
          cellType: 'date',
          Filter: d => <TableFilterDateRange {...d} />,
        },
        {
          // API needs to filter by therapycategory but UI needs to show prcvisittype
          id: 'therapycategory',
          Header: 'Therapy Type',
          accessor: 'attributes.prcvisittype',
          Filter: d => <TableFilterAppointmentType {...d} />,
        },
        {
          id: 'primarydx',
          Header: 'Primary Diagnosis',
          accessor: 'attributes.primarydx',
        },
        {
          id: 'sourceDescription',
          Header: 'Reporting Healthcare Insitution',
          accessor: 'attributes.sourceDescription',
          Filter: d => <TableFilterIdentitySource {...d} />,
        },
        {
          id: 'hasNotes',
          Header: 'Notes',
          accessor: 'attributes.hasNotes',
          filterable: false,
          Cell: n => <NoteCell {...n} />,
        },
      ]}
      SubComponent={({ original: row }) => (
        <div className="p-3">
          <Row>
            <Col sm={2}>
              <h6 className="text-primary">Location</h6>
              {row.attributes.departmentname}
            </Col>

            <Col sm>
              <h6 className="text-primary">Additional Diagnosis</h6>
              {row.attributes.additionaldx}
            </Col>
          </Row>
        </div>
      )}
    />
  );
};

export default TherapyVisits;
